import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import customers from '../../../../assets/img/customers.png';
import newCustomers from '../../../../assets/img/new-customers.png';
import requests from '../../../../assets/img/requests.png';
import notifications from '../../../../assets/img/notifications.png';
import CustomDatepicker from '../../../../components/CustomDatepicker/CustomDatepicker';
import { Calendar, Vector } from '../../../../components/Svg/Svg';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

export default function ClientDashboardSubPage() {
    const params = useParams();
    const [isShown, setIsShown] = useState(false);
    const [savedStartDate, setSavedStartDate] = useState(new Date());
    const [savedEndDate, setSavedEndDate] = useState(new Date());
    const [date, setDate] = useState(
        `${moment().format('DD MMM yyyy')} - ${moment().format('DD MMM yyyy')}`,
    );

    useEffect(() => {
        if (params['*'] !== 'dashboard') {
            setIsShown(false);
        }
    }, [params]);

    const getDate = (dateStr, dateObj) => {
        setSavedStartDate(dateObj.start);
        setSavedEndDate(dateObj.end);
        setDate(dateStr);
    };

    return (
        <div>
            <div className="terms-and-privacy-buttons__wrapper">
                <h2 className="title__main-text--sub-page">Dashboard</h2>
                <div>
                    <div
                        className="datepicker__date-frame"
                        onClick={() => setIsShown(!isShown)}
                    >
                        <Calendar />
                        <span className="datepicker__date-frame-text">
                            {date}
                        </span>
                        <span
                            className={`${
                                isShown ? 'datepicker__date-frame--isOpen' : ''
                            }`}
                        >
                            <Vector />
                        </span>
                    </div>

                    {isShown && (
                        <CustomDatepicker
                            getDate={getDate}
                            setIsShown={() => setIsShown(false)}
                            savedStartDate={savedStartDate}
                            savedEndDate={savedEndDate}
                        />
                    )}
                </div>
            </div>
            <div className="metrics__wrapper">
                <img
                    className="metrics__thumb"
                    src={customers}
                    alt="Customers"
                    width={257}
                    height={244}
                />
                <img
                    className="metrics__thumb"
                    src={newCustomers}
                    alt="New customers"
                    width={257}
                    height={244}
                />
                <img
                    className="metrics__thumb"
                    src={requests}
                    alt="Requests"
                    width={257}
                    height={244}
                />
                <img
                    className="metrics__thumb"
                    src={notifications}
                    alt="Notifications"
                    width={257}
                    height={244}
                />
            </div>
        </div>
    );
}
